import { api, runtime, normalizeCommitteeProfile } from "../api.js";
import { posterUrl } from "../posters.js";
import { shell, pageHeading, statusPanel, matchCard, hydrateCommitteeIdentity, championshipActions } from "../components.js";
import { escapeHtml, errorMessage, formatDateLabel, nonRedundantSubtitle, selectedCommittee } from "../utils.js";

let refreshTimer;

function dayOptions() {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Array.from({ length: 7 }, (_, index) => {
    const date = new Date(today);
    date.setDate(today.getDate() + index - 3);
    return { date, timestamp: Math.floor(date.getTime() / 1000), today: index === 3 };
  });
}

export async function liveView(signal) {
  clearTimeout(refreshTimer);
  const committee = selectedCommittee();
  document.title = "Gare di oggi | FIPAV Online";
  if (!committee) {
    document.querySelector("#app").innerHTML = shell(
      pageHeading("Gare di oggi") + statusPanel("Seleziona prima un comitato.", "error") +
      '<div class="container"><a class="button" href="/" data-link>Scegli comitato</a></div>',
    );
    return;
  }
  const days = dayOptions();
  let selected = days.find((day) => day.today).timestamp;
  document.querySelector("#app").innerHTML = shell(`
    ${pageHeading("Gare di oggi")}
    <div class="date-tabs container" role="group" aria-label="Filtra per data">
      ${days.map((day) => `<button type="button" data-day="${day.timestamp}" class="${day.today ? "active" : ""}">${formatDateLabel(day.date)}</button>`).join("")}
      <button type="button" data-day="0">Tutte</button>
    </div>
    <div id="live-content">${statusPanel("Caricamento gare…")}</div>`, { committee });

  let payload;
  let posters = {};
  const paint = () => {
    const root = document.querySelector("#live-content");
    if (!root || !payload) return;
    const championships = payload.data?.championship || [];
    const sections = championships.map((championship) => {
      const subtitle = nonRedundantSubtitle(championship.title, championship["sub-title"]);
      const matches = (championship["championship-matches"] || []).filter((match) =>
        selected === 0 || (Number(match.ts_gara) >= selected && Number(match.ts_gara) < selected + 86400),
      );
      if (!matches.length) return "";
      return `<section class="championship-block container">
        <div class="section-title"><div>${subtitle ? `<small>${escapeHtml(subtitle)}</small>` : ""}<h2>${escapeHtml(championship.title)}</h2></div>
          ${championshipActions(championship.id)}
        </div>
        <div class="match-list">${matches.map((match) => matchCard(match, championship.title, { poster: posterUrl(posters[String(match.id)], runtime.r2Origin) })).join("")}</div>
      </section>`;
    }).filter(Boolean);
    root.innerHTML = sections.join("") || statusPanel("Nessuna gara nella data selezionata.", "empty");
  };

  document.querySelectorAll("[data-day]").forEach((button) => button.addEventListener("click", () => {
    selected = Number(button.dataset.day);
    document.querySelectorAll("[data-day]").forEach((item) => item.classList.toggle("active", item === button));
    paint();
  }));

  const load = async () => {
    try {
      payload = await api.live(committee, signal);
      if (payload.redirect) throw new Error("Questa pagina è temporaneamente disponibile solo sul sito storico.");
      const profile = payload.data?.commettees?.["my-commettee"];
      if (profile) {
        // Il JSON su disco contiene gia l'identita: nessuna chiamata PHP ai comitati.
        await hydrateCommitteeIdentity({ committeeProfile: async () => normalizeCommitteeProfile(profile) }, committee, signal);
      }
      paint();
      // Indice separato: i JSON statici legacy restano invariati; nessun fallback PHP.
      try {
        const index = await api.posters(committee, signal);
        if (signal.aborted) return;
        posters = index.data || {};
      } catch (error) {
        if (error.name === "AbortError" || signal.aborted) return;
        posters = {}; // Un indice assente non impedisce di visualizzare le gare.
      }
      paint();
      refreshTimer = window.setTimeout(load, runtime.refreshMs);
    } catch (error) {
      if (error.name !== "AbortError" && !signal.aborted) {
        document.querySelector("#live-content").innerHTML = statusPanel(errorMessage(error), "error");
        refreshTimer = window.setTimeout(load, runtime.refreshMs);
      }
    }
  };
  await load();
}

export function stopLiveRefresh() {
  clearTimeout(refreshTimer);
}
